function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("style", null, ".st130{fill:#7dc58b}.st140{fill:none;stroke:#ef6158;stroke-miterlimit:10}.st160{fill:#4ca878}.st178,.st180,.st181{fill:none;stroke-miterlimit:10}.st178{stroke:#aa4a31;stroke-width:2}.st180,.st181{stroke:#c69337}.st181{stroke:#5870b2}");

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "st178",
  d: "M79.6 102.2C79.6 62.5 62.8 0 62.8 0M75.9 117.6c0-39.7 16.9-102.2 16.9-102.2"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M101.3 136H57.9c-11.8-10.5-12.9-21.4 4.6-37.1C73.1 89.3 74.8 76 74.8 76h9.6s1.7 13.3 12.3 22.9c17.5 15.8 16.5 26.6 4.6 37.1z",
  fill: "#16505e"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#ebc8aa",
  d: "M0 136h232.8v10.8H0z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "st160",
  d: "M38.4 120.4c-.8-.6-.8-2.1 0-3.5l3.5-6.3c1.4-2.5 3.3-4.7 5.4-6.4l8.3-6.5-4.1 9.8c-1 2.5-2.7 4.9-4.7 6.9l-5.2 5.1c-1 1.1-2.4 1.5-3.2.9z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "st160",
  d: "M38.4 120.4c-1 .2-2.1-.7-2.7-2.3l-2.6-6.8c-1-2.6-1.5-5.5-1.4-8.3l.4-10.6 4.9 9.4c1.3 2.4 2.1 5.2 2.3 8.1l.6 7.2c.1 1.7-.5 3.1-1.5 3.3z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "st130",
  d: "M38.4 120.4c-.8.6-2.2.2-3.4-.9l-5.2-5.1c-2-2-3.7-4.4-4.8-6.9l-4.1-9.7 8.4 6.4c2.2 1.7 4.1 3.9 5.5 6.3l3.6 6.3c.8 1.5.8 3 0 3.6z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "st130",
  d: "M38.4 120.4c-1-.2-1.6-1.5-1.5-3.2l.5-7.2c.2-2.8 1-5.7 2.2-8.1l4.8-9.4.4 10.6c.1 2.7-.4 5.6-1.3 8.3l-2.5 6.8c-.5 1.5-1.6 2.4-2.6 2.2z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "st160",
  d: "M36.6 120.4c-.5-.9.1-2.2 1.5-3.2L44 113c2.3-1.7 5-2.9 7.6-3.5l10.3-2.4-7.8 7.1c-2 1.8-6.3 4.9-8.6 5.9-2.4 1-3.1 1.1-5.2 1.1-2.2.1-3.2.1-3.7-.8z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "st160",
  d: "M40.4 120.4c-.5.9-.7.9-3 .9s-4.8-1.2-4.8-1.2c-2.7-.9-7.7-3.9-9.7-5.7l-7.9-7.1 10.3 2.3c2.7.6 5.3 1.8 7.6 3.4l5.9 4.2c1.4 1 2 2.3 1.6 3.2z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M58 117.1c0 10.5-8.5 19-19 19s-19-8.5-19-19h38z",
  fill: "#59bcc2"
});

var _ref12 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "SVGID_2_",
  gradientUnits: "userSpaceOnUse",
  x1: 124.589,
  y1: 147.38,
  x2: 124.589,
  y2: 160.582
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#dbd9d1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#d1d0d1",
  stopOpacity: 0
}));

var _ref13 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.6,
  fill: "url(#SVGID_2_)",
  d: "M232.8 146.8H0L16.4 160h232.8z"
});

var _ref14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M184 134.8l-14.6 1.2c-.3 0-.6-.2-.6-.5l-11-132.7c0-.3.2-.6.5-.6L172.9 1c.3 0 .6.2.6.5l11 132.7c0 .3-.2.5-.5.6z",
  fill: "#d7af3e"
}), /*#__PURE__*/React.createElement("path", {
  className: "st180",
  d: "M183.9 127.4l-15.6 1.3M183.7 124l-15.7 1.3M174.3 11.3l-15.6 1.3M174 7.9l-15.6 1.3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M171.3 69.6c1.1-.1 2.1.7 2.2 1.8l3.8 45.2c.1 1.1-.7 2.1-1.8 2.2-1.1.1-2.1-.7-2.2-1.8l-3.8-45.2c-.2-1.2.7-2.2 1.8-2.2z",
  fill: "#edd48b"
}), /*#__PURE__*/React.createElement("path", {
  className: "st180",
  d: "M167.3 22.1l2.8 33.3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M210.4 133.5l-14.4 2.4c-.3 0-.6-.2-.6-.5L173.7 4.1c0-.3.2-.6.5-.6l14.4-2.4c.3 0 .6.2.6.5L210.8 133c.1.2-.1.5-.4.5z",
  fill: "#f59d98"
}), /*#__PURE__*/React.createElement("path", {
  className: "st140",
  d: "M209.7 126.2l-15.5 2.5M209.2 122.8l-15.5 2.6M190.8 11.3l-15.5 2.5M190.3 7.9l-15.5 2.6M184.7 22.6l5.5 33"
}), /*#__PURE__*/React.createElement("path", {
  d: "M159.4 135V20.1c0-.6-.5-1.1-1.1-1.1h-23.7c-.6 0-1.1.5-1.1 1.1V135c0 .6.5 1.1 1.1 1.1h23.7c.6 0 1.1-.5 1.1-1.1z",
  fill: "#323e6a"
}), /*#__PURE__*/React.createElement("path", {
  className: "st181",
  d: "M159.4 122.1h-25.8M159.4 125.1h-25.8M159.4 30.4h-25.8M159.4 33.5h-25.8"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#7d97cb",
  d: "M143.7 55.6h5.5v43.9h-5.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st181",
  d: "M146.5 39.1V50M146.5 107v11"
}));

function SvgUnderstandingYourData(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 250 160",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderstandingYourData);
export default __webpack_public_path__ + "understandingYourData.5f0cdadac37bdd00d5cd08bed2085762.svg";
export { ForwardRef as ReactComponent };